import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { INPUT_TYPE, FORM_TYPE, KEYS, STRING } from 'projects/common/src/app/types';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-simple-text',
  templateUrl: './simple-text.component.html',
  styleUrls: ['./simple-text.component.css']
})
export class SimpleTextComponent implements OnInit {
  @Input() formElement: any = {};
	@Input() label = STRING.EMPTY;
	@Input() required = false;
	rowClass: any;
	@Input() name: string;
	@Input() placeholder = STRING.EMPTY;
	@Input() formValue?: FormGroup;
	private _dateValue: any;
	labelClass: any;
	inputClass: any = [];
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	set dateValue(value) {
		this._dateValue = value;
		this.value = value;
	}
	get dateValue() {
		const stringDate = Helpers.toCalendarDate(this.value);
		return stringDate;
	}
	@Input()
	set value(text: any) {
		this._value = text;
		if (this._value !== STRING.EMPTY && this.value !== null) {
			this.onChange();
		}
	}
	get value() {
		if (this.type === INPUT_TYPE.NUMBER) {
			this._value = this._value ? this._value : null;
		}
		if (this._value) {
			if (this.type === INPUT_TYPE.NUMBER) {
				this._value = parseInt(this._value, 10);
			}
			if (this.type === INPUT_TYPE.DATE && this.formElement.emitInDateFormat) {
				this._value = Helpers.toDateFromCalendar(this._value);
			}
		}

		return this._value;
	}
	@Input() type: any = INPUT_TYPE.TEXT;
	@Input() disabled = false;
	@Output() valueChange = new EventEmitter();
	@Output()
	change = new EventEmitter<{
		name: string;
		value: string;
	}>();
	@Output()
	blur = new EventEmitter<{
		name: string;
		value: string;
	}>();
	_value;
	constructor(private scriptLoaderService: ScriptLoaderService) { }

	private _formatView() {
		this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
		const labelDiv = this.formElement.labelDiv;
		const inputDiv = this.formElement.inputDiv;
		if (this.formElement.type === INPUT_TYPE.DATE) {
			this.inputClass.push('input-height input-group');
		}
		let derivedLabelClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)
		];
		let derivedInputClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)
		];
		if (this.formElement.row) {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row
			];
			derivedLabelClass.push(
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row
			);
		} else {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.flexRow
			];
			derivedInputClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
			derivedLabelClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
		}
		this.inputClass = this.inputClass.concat(derivedInputClass);
		this.labelClass = this.labelClass.concat(derivedLabelClass);
	}

	// private _formatView() {
	// 	this.labelClass = ['col-form-label field-label'];
	// 	this.inputClass = [];
	// 	if (this.formElement.type === INPUT_TYPE.DATE) {
	// 		this.inputClass.push('input-height input-group');
	// 	}
	// 	let derivedLabelClass = [];
	// 	let derivedInputClass = [];
	// 	if (this.formElement.align && this.formElement.align === 6) {
	// 		derivedLabelClass.push('col-4');
	// 		derivedInputClass.push('col-8');
	// 	} else {
	// 		derivedLabelClass.push('col-2');
	// 		derivedInputClass.push('col-10');
	// 	}
	// 	const labelDiv = this.formElement.labelDiv;
	// 	const inputDiv = this.formElement.inputDiv;
	// 	derivedLabelClass = [`col-${labelDiv}`];
	// 	derivedInputClass = [`col-${inputDiv}`];
	// 	if (this.formElement.row) {
	// 		this.rowClass = ['row'];
	// 		derivedLabelClass.push('right-text');
	// 	} else {
	// 		derivedInputClass = ['col-12'];
	// 		derivedLabelClass = ['col-12'];
	// 	}
	// 	this.inputClass = this.inputClass.concat(derivedInputClass);
	// 	this.labelClass = this.labelClass.concat(derivedLabelClass);
	// }
	ngOnInit() {
		// if (this.formElement.name === "numberOfTransGenderWashRooms") {
		// 	console.log("inside text")
		// 	console.log(this.formElement);
		// }
		if (this.formElement && this.formElement.onInit) {
			this.formElement.onInit();
		}
		this.type = this.formElement.type || this.type;
		if (this.formValue) {
			this.formValue.valueChanges.subscribe(val => {
				this.onFormValueChange(val);
			});
			if (Helpers.isValidValue(this.formValue.value) && this.value !== this.formValue.value) {
				this.onFormValueChange(this.formValue.value);
			}
		}
		if (this.formElement && this.formElement.onInit) {
			this.formElement.onInit();
		}
		if (this.formElement || Object.keys[this.formElement] !== 0) {
			this._formatView();
			this.disabled = this.formElement.disabled || false;
			this.value = isNullOrUndefined(this.formElement.value) ? STRING.EMPTY : this.formElement.value;
			if (this.value) {
			}
		}
		this.scriptLoaderService.addScriptTagToElementDOM(
			FORM_STYLE_CONFIG.datePicker[FORM_STYLE_CONFIG.datePicker.default]
		);
	}

	onFormValueChange(val) {
		if (!(this.value === val)) {
			this.value = val;
			this.formValue.markAsPristine();
		}
		if (this.formElement.markAsUntouched) {
			this.formValue.markAsPristine();
			this.formValue.markAsUntouched();
			this.formElement.markAsUntouched = false;
		}
	}

	focus(id) {
		Helpers.focuseOn(id);
	}

	isDisabled() {
		return (this.disabled || this.formElement.readOnly) ? STRING.EMPTY : null;
	}

	set inputValue(value) {
		if (this.formValue) {
			this.formValue.setValue(this.value);
		}
	}

	onBlur() {
		this.makeDirty();
		if (this.value === undefined) {
			return;
		}
		this.blur.emit({
			name: this.formElement.name,
			value: this.value
		});
	}

	onChange() {
		if (this.value === undefined || Number.isNaN(this.value)) {
			return;
		}
		this.makeDirty();
		this.inputValue = this.value;
		this.valueChange.emit(this.value);
		this.change.emit({
			name: this.formElement.name,
			value: this.value
		});
	}
	makeDirty() {
		if (this.formValue) {
			this.formValue.markAsDirty();
			this.formValue.markAsTouched();
		}
	}

	onKeydown(event) {
		const allowedKeys: any = [
			KEYS.BACKSPACE,
			KEYS.ARROW_LEFT,
			KEYS.ARROW_RIGHT,
			KEYS.TAB];
		const key: string = event.key;
		if (allowedKeys.indexOf(key) >= 0) {
			return;
		}
		const currentValue = this.value === null ? STRING.EMPTY : String(this.value);
		if (this.formElement.type === INPUT_TYPE.NUMBER) {
			if (currentValue === STRING.EMPTY && key === STRING.ZERO ) {
				return event.preventDefault();
			}
		}
		if (this.formElement.maxFieldLength >= 0) {
			if (this.formElement.maxFieldLength === currentValue.length) {
				return event.preventDefault();
			}
		}
		const charAllowedPattern = this.formElement.charPattern;
		if (!charAllowedPattern) {
			return;
		}
		const charAllowedRegex = new RegExp(charAllowedPattern, 'g');
		const match = key && key.match(charAllowedRegex);
		if (!match) {
			event.preventDefault();
		}
	}
	discardKey(event) {
		const key: string = event.key;
		const allowedKeys: any = [KEYS.TAB];
		if (allowedKeys.indexOf(key) >= 0) {
			return;
		}
		event.preventDefault();
	}
}
